import clsx, { ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const COLORS = {
   orange: "#F15A29",
   blue: "#1C75BC",
   yellow: "#F7941D",
   topic_banner: {
      gray1: "#fefefe",
   },
}

export function cn(...inputs: ClassValue[]) {
   return twMerge(clsx(inputs))
}
